"use strict";

import React, {Component} from "react";
import "react-table/react-table.css";

import VideoEnrichmentEventReport from "../../component/EnrichedVideo/Widget/VideoEnrichmentEventReport";
import {FilterConsumer} from "../../context/FilterContext";
import SummaryReport from "../../component/EnrichedVideo/Widget/SummaryReport";

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <FilterConsumer>
                    {(context) => <VideoEnrichmentEventReport filterContext={context} /> }
                </FilterConsumer>
            </div>
        );
    }
}

export default Home;
